module.exports = __webpack_public_path__ + "img/add_lock_5.2770554c.png";